// FIXME: Fix import/named export issue for firebase
/* eslint-disable import/named */
import { getIdToken, getIdTokenResult, updateProfile, updateEmail, getAuth } from 'firebase/auth'
import { createUserFromToken } from './auth-helper'

function parseFirebaseUser (currentUser) {
	return {
		uid: currentUser.uid,
		name: currentUser.displayName || '',
		fullName: currentUser.displayName || '',
		firstName: currentUser.displayName ? currentUser.displayName.split(' ')[0] : '',
		lastName: currentUser.displayName ? currentUser.displayName.split(' ')[1] : '',
		email: currentUser.email,
		emailVerified: currentUser.emailVerified,
		meta: { }
	}
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {*} formatted if `false` will return `firebase.currentUser` if `true` will format response
 */
function getFirebaseCurrentUser (firebaseAuth, formatted = true) {
	if (process.env.USER_TOKEN) {
		return createUserFromToken(process.env.USER_TOKEN)
	}
	if (!firebaseAuth || !firebaseAuth.currentUser) {
		return null
	}

	if (formatted) {
		return parseFirebaseUser(firebaseAuth.currentUser)
	}

	return firebaseAuth.currentUser
}

/**
 * Validates if token will expire soon or not.
 * By default will compare at 5 minutes before expiration time.
 *
 * @param {*} exp - expiration time received from firebase result.claims
 * @returns {boolean}
 *   `true` - if token is expired or will expire in next 5 minutes,
 * 	 `false` - otherwise
 */
function validateTokenExpiration (exp) {
	const MIN_BEFORE_EXPIRATION = 10
	const comparedAt = new Date(exp * 1000)

	// subtract `MIN_BEFORE_EXPIRATION` from `expiresAt` time
	// so we will do a token refresh before `expiresAt` time
	comparedAt.setMinutes(comparedAt.getMinutes() - MIN_BEFORE_EXPIRATION)

	return comparedAt < new Date()
}

/**
 * @param {*} firebaseAuth firebase auth instance
	* @param {*=} user firebase currentUser instance (optional)
 * @param {*=} forceUpdate update token (optional)
 * @return {string|null}
 */
async function getFirebaseCurrentUserIdToken (firebaseAuth, user = null, forceUpdate) {
	const auth = forceUpdate ? getAuth() : firebaseAuth
	const currentUser = user || await getFirebaseCurrentUser(auth, false)

	if (currentUser) {
		const result = await getIdTokenResult(currentUser, forceUpdate)
		const isExpired = validateTokenExpiration(result.claims.exp)

		if (isExpired) {
			return await getIdToken(currentUser, true)
		}

		return result.token
	}

	return null
}

async function updateFirebaseUserProfile (firebaseAuth, profilePayload) {
	const currentUser = await getFirebaseCurrentUser(firebaseAuth, false)

	return updateProfile(currentUser, profilePayload)
}

async function updateFirebaseUserEmail (firebaseAuth, profilePayload) {
	const currentUser = await getFirebaseCurrentUser(firebaseAuth, false)

	return updateEmail(currentUser, profilePayload)
}

export default {
	getUser: getFirebaseCurrentUser,
	getUserIdToken: getFirebaseCurrentUserIdToken,
	updateUserEmail: updateFirebaseUserEmail,
	updateUserProfile: updateFirebaseUserProfile,
	parseUser: parseFirebaseUser
}
